export const DEFAULT_DATA = {
    Origin: 'Homepage',
};
